var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row h-items-center"},[_c('GetMoves',{attrs:{"movimientos":_vm.update_moves,"limite":_vm.limit_pagination}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }